import React from 'react';
import { Alert as MuiAlert, AlertTitle } from '@mui/material';
import type { AlertProps } from '@mui/material';

interface Props extends AlertProps {
  title?: string;
  description?: string;
}

const Alert = ({
  children,
  title,
  description,
  severity = 'info',
  ...alertProps
}: Props) => {
  const content = description !== undefined ? (
    <>
      {title && <AlertTitle>{title}</AlertTitle>}
      {description}
    </>
  ) : children;

  return (
    <MuiAlert severity={severity} {...alertProps}>
      {content}
    </MuiAlert>
  );
};

export default Alert;
